export default __webpack_public_path__ + "static-bigflip/media/npwp.b8899629.webp";